import React from 'react';
import { Pencil, Trash2 } from 'lucide-react';
import type { IntakeRecord } from '../../types/data';
import { GenericTable } from '../GenericTable/GenericTable';

interface IntakeListProps {
  records: IntakeRecord[];
  onEdit: (record: IntakeRecord) => void;
  onDelete: (id: string) => void;
}

export const IntakeList: React.FC<IntakeListProps> = ({
  records,
  onEdit,
  onDelete,
}) => {
  if (records.length === 0) {
    return (
      <div className="text-center py-8 text-gray-500">
        No intake records found. Add one to get started.
      </div>
    );
  }

  return (
    <div>
      <GenericTable
        data={records}
        columns={[
          { key: 'name', label: 'Name', sticky: 'left' },
          {
            key: 'dosage_taken',
            label: 'Dosage Taken',
            render: (item) =>
              `${item.dosage_taken ?? 'N/A'} ${item.dosage_units ?? ''}`.trim(),
          },
          {
            key: 'intake_time',
            label: 'Date & Time',
            render: (item) =>
              item.intake_time
                ? new Date(item.intake_time).toLocaleString()
                : 'N/A',
          },
          {
            key: 'actions',
            label: 'Actions',
            sticky: 'right',
            render: (item) => (
              <div className="flex gap-3">
                <button
                  onClick={() => onEdit(item)}
                  className="text-blue-600 hover:text-blue-800 transition-colors"
                  title="Edit record"
                >
                  <Pencil className="w-5 h-5" />
                </button>
                <button
                  onClick={() => onDelete(item.id!)}
                  className="text-red-600 hover:text-red-800 transition-colors"
                  title="Delete record"
                >
                  <Trash2 className="w-5 h-5" />
                </button>
              </div>
            ),
          },
        ]}
      />
    </div>
  );
};
